<table mat-table matSort [dataSource]="dataSource" data-testid="scenarios-table">
  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? toggleAllRows() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        [aria-label]="checkboxLabel()"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (keyUp)="$event.stopPropagation()"
        (change)="$event ? onCheckChange(row) : null"
        [checked]="selection.isSelected(row)"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="Price Zone">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      sortActionDescription="Sort by Price Zone"
    >
      Price Zone
    </th>
    <td mat-cell *matCellDef="let scenario">{{ scenario.zoneName }} - {{ scenario.zoneAlias }}</td>
  </ng-container>

  <ng-container matColumnDef="Source">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
    <td mat-cell *matCellDef="let scenario">{{ scenario.source }}</td>
  </ng-container>

  <ng-container matColumnDef="Release">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Release </th>
    <td mat-cell *matCellDef="let scenario">{{ scenario.sourcePublicationDate }}
      <tds-icon
        name="info"
        matTooltip="{{ scenario?.unifiedPublicationDate | date:'dd/MM/yyyy' }}"
        matTooltipPosition="right" size="xs" class="help"
        style="position: relative; top: 3px;">
      </tds-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="Scenario">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Scenario</th>
    <td mat-cell *matCellDef="let scenario">{{ scenario.basecase }}</td>
  </ng-container>

  @if(advancedMode()) {
    <ng-container matColumnDef="Weather Year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header >Weather Year</th>
      <td mat-cell *matCellDef="let scenario">{{ scenario.weatherYear }}</td>
    </ng-container>
  }

  <ng-container matColumnDef="Baseload / Captured">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Baseload / Captured</th>
    <td mat-cell *matCellDef="let scenario">{{ scenario.subtype }}</td>
  </ng-container>

  <ng-container matColumnDef="Actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let scenario">
      <button
        tds-icon-button
        label="Chat"
        (click)="openDialog(scenario.analyst)"
        [disabled]="!scenario.analyst"
      >
        <tds-icon name="chat"></tds-icon>
      </button>

      @if(subscriptionIsNotActive(scenario)) {
        <button  tds-icon-button label="Subscribe" (click)="openSubscriptionModal(scenario)">
          <tds-icon name="notification_add"></tds-icon>
        </button>
      } @else {
        <button  tds-icon-button label="Already subscribed" disabled>
          <tds-icon name="notifications_active"></tds-icon>
        </button>
      }

        <button
                tds-icon-button
                label="Download the Power Market Outlook"
                (click)="downloadAnalystFile(scenario)"
                [disabled]="!scenario.pmoFileUrl"
        >
            <tds-icon name="file_open"></tds-icon>
        </button>
        <button tds-icon-button label="Request hourly data" (click)="openHourlyDataRequestModal(scenario)">
          <tds-icon name="database_search"></tds-icon>
        </button>
    </td>
  </ng-container>

    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"  ></tr>
    <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
</table>
<mat-paginator
  [length]="scenarios.length"
  [pageSizeOptions]="[5, 10, 50, 100]"
  aria-label="Select page"
>
</mat-paginator>
